function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash';
import { CANNABIS_TYPES } from 'shared/core/constants/product';
import { getComplianceConfig } from 'shared/core/helpers/compliance';
import { MG_TO_G, POTENCY_TYPES } from 'shared/constants';
import { safeToBig } from 'shared/helpers/utils_math';
import { getKeyFromTAC, getProductWeight, getEquivalent, getProductNetWeightInGrams, getProductVolumeInGrams } from 'shared/helpers/products';
import { CONCENTRATE_TYPES, EDIBLE_TYPES, TINCTURE_TYPES, TOPICAL_TYPES, GRAMS_PER_OUNCE } from './constants';
import { getStateLimits, getTypeLimits, getLimitMessage, getLimitForType, getEffectiveSubcategories, isFlower, isConcentrate, isEdible, isTincture, isTopical, isWeightedProduct, isLiquidTypeProduct, isSolidEdibleTypeProduct, formatDisplayedType } from './utils';
import { checkSolidEdibleNetWeight } from './check-solid-edible-net-weight';
import { checkLiquidEdibleVolume } from './check-liquid-edible-volume';
export var shouldCombine = function(limits, medical) {
    if (medical) {
        return limits.medUsesEquivalencyCalculator;
    }
    return limits.usesEquivalencyCalculator;
};
/**
 * This function is used to check the current product type and its subcategory
 * against any type maps that exist in a state/region's compliance configuration
 */ var isTypeMapType = function() {
    var typeFromCartProduct = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '', subcategoriesFromCartProduct = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], limits = arguments.length > 2 ? arguments[2] : void 0, category = arguments.length > 3 ? arguments[3] : void 0;
    var categories = _.get(limits, "typeMap.".concat(category, ".categories"), []);
    var subcategories = _.get(limits, "typeMap.".concat(category, ".subcategories"), []);
    var allCategoriesForType = _to_consumable_array(categories).concat(_to_consumable_array(subcategories));
    return _.includes(allCategoriesForType, typeFromCartProduct) || _.intersection(allCategoriesForType, subcategoriesFromCartProduct).length > 0;
};
var isIgnoreTypeMapType = function(typeFromCartProduct, subcategoriesFromCartProduct, limits, category) {
    var ignoredCategories = _.get(limits, "ignoreTypeMap.".concat(category, ".categories"), []);
    var ignoredSubcategories = _.get(limits, "ignoreTypeMap.".concat(category, ".subcategories"), []);
    var allIgnoredCategoriesForType = _to_consumable_array(ignoredCategories).concat(_to_consumable_array(ignoredSubcategories));
    return _.includes(allIgnoredCategoriesForType, typeFromCartProduct) || _.intersection(allIgnoredCategoriesForType, subcategoriesFromCartProduct).length > 0;
};
export var getMultiplier = function(productType, limits, medical) {
    var subcategories = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    if (shouldCombine(limits, medical)) {
        var multType = medical ? 'med' : 'rec';
        // Some states have nested multipliers specific for rec/med
        // Use the nested multiplier if it exists
        // If not, then use the non-nested multiplier
        if (isFlower(productType) && !isIgnoreTypeMapType(productType, subcategories, limits, 'Flower')) {
            return 1;
        }
        if (limits.usesSolidEdibleTypes && isSolidEdibleTypeProduct(productType, subcategories)) {
            return _.get(limits.solidNetWeightMultiplier, multType, limits.solidNetWeightMultiplier) || 0;
        }
        if (limits.usesLiquidTypes && isLiquidTypeProduct(limits, productType, subcategories)) {
            return _.get(limits.liquidNetWeightMultiplier, multType, limits.liquidNetWeightMultiplier) || 0;
        }
        if (_.includes(CONCENTRATE_TYPES, productType) || isTypeMapType(productType, subcategories, limits, 'Concentrate')) {
            return _.get(limits.concentrateMultiplier, multType, limits.concentrateMultiplier) || 0;
        }
        if (_.includes(EDIBLE_TYPES, productType) || isTypeMapType(productType, subcategories, limits, 'Edible')) {
            return _.get(limits.edibleMultiplier, multType, limits.edibleMultiplier) || 0;
        }
        if (_.includes(TINCTURE_TYPES, productType) || isTypeMapType(productType, subcategories, limits, 'Tincture')) {
            return _.get(limits.tinctureMultiplier, multType, limits.tinctureMultiplier) || 0;
        }
        if (_.includes(TOPICAL_TYPES, productType) || isTypeMapType(productType, subcategories, limits, 'Topicals')) {
            return _.get(limits.topicalMultiplier, multType, limits.topicalMultiplier) || 0;
        }
    }
    if (isFlower(productType)) {
        return 1;
    }
    return 0;
};
export var cartHasMix = function(cart) {
    var limits = cart.limits, useMultiSubcategories = cart.useMultiSubcategories;
    var productTypes = _.uniq(_.map(cart.orders, function(param) {
        var product = param.product;
        return product.type;
    }));
    var productSubcategories = _.uniq(_.flatMap(cart.orders, function(param) {
        var product = param.product;
        return getEffectiveSubcategories(product, useMultiSubcategories);
    }));
    var allTypes = _to_consumable_array(productTypes).concat(_to_consumable_array(productSubcategories));
    var hasConcentrates = !!_.find(allTypes, isConcentrate) || !!_.find(allTypes, function(type) {
        return isTypeMapType(type, [
            type
        ], limits, 'Concentrate');
    });
    var hasFlower = !!_.find(allTypes, isFlower) || !!_.find(allTypes, function(type) {
        return isTypeMapType(type, [
            type
        ], limits, 'Flower');
    });
    var hasEdibles = !!_.find(allTypes, isEdible) || !!_.find(allTypes, function(type) {
        return isTypeMapType(type, [
            type
        ], limits, 'Edible');
    });
    var hasTinctures = !!_.find(allTypes, isTincture) || !!_.find(allTypes, function(type) {
        return isTypeMapType(type, [
            type
        ], limits, 'Tincture');
    });
    var hasTopicals = !!_.find(allTypes, isTopical) || !!_.find(allTypes, function(type) {
        return isTypeMapType(type, [
            type
        ], limits, 'Topicals');
    });
    return _.compact([
        hasFlower,
        hasConcentrates,
        hasEdibles,
        hasTinctures,
        hasTopicals
    ]).length > 1;
};
var getPotencyRanges = function(product) {
    var _product_THCContent, _product_CBDContent;
    if (!product) {
        return {};
    }
    var cannabinoids = _.get(product, 'cannabinoidsV2', []);
    var tacPotencyValue = getKeyFromTAC(cannabinoids, "value", 0);
    var tacPotencyRangeV2 = [
        tacPotencyValue,
        tacPotencyValue
    ];
    var thcPotencyUnit = _.get(product, 'THCContent.unit');
    var thcPotencyRange;
    var netWeightInMg = _.get(product, 'measurements.netWeight.values[0]');
    if (thcPotencyUnit === 'PERCENTAGE' && _.isArray(product === null || product === void 0 ? void 0 : (_product_THCContent = product.THCContent) === null || _product_THCContent === void 0 ? void 0 : _product_THCContent.range) && netWeightInMg) {
        var range = product.THCContent.range.map(function(percentage) {
            return parseFloat(percentage) / 100 * netWeightInMg;
        });
        thcPotencyRange = range;
    } else {
        var _product_THCContent1;
        thcPotencyRange = _.isArray(product === null || product === void 0 ? void 0 : (_product_THCContent1 = product.THCContent) === null || _product_THCContent1 === void 0 ? void 0 : _product_THCContent1.range) ? product.THCContent.range : [
            0,
            0
        ];
    }
    var cbdPotencyRange;
    var cbdPotencyUnit = _.get(product, 'CBDContent.unit');
    if (cbdPotencyUnit === 'PERCENTAGE' && _.isArray(product === null || product === void 0 ? void 0 : (_product_CBDContent = product.CBDContent) === null || _product_CBDContent === void 0 ? void 0 : _product_CBDContent.range) && netWeightInMg) {
        var range1 = product.CBDContent.range.map(function(percentage) {
            return parseFloat(percentage) / 100 * netWeightInMg;
        });
        cbdPotencyRange = range1;
    } else {
        var _product_CBDContent1;
        cbdPotencyRange = _.isArray(product === null || product === void 0 ? void 0 : (_product_CBDContent1 = product.CBDContent) === null || _product_CBDContent1 === void 0 ? void 0 : _product_CBDContent1.range) ? product.CBDContent.range : [
            0,
            0
        ];
    }
    // for each cannabinoid, if range does not have two values, give it two values
    if (cbdPotencyRange.length !== 2) {
        cbdPotencyRange = [
            0
        ].concat(_to_consumable_array(cbdPotencyRange));
    }
    if (thcPotencyRange.length !== 2) {
        thcPotencyRange = [
            0
        ].concat(_to_consumable_array(thcPotencyRange));
    }
    var _obj;
    return _obj = {}, _define_property(_obj, POTENCY_TYPES.CBD, cbdPotencyRange), _define_property(_obj, POTENCY_TYPES.THC, thcPotencyRange), _define_property(_obj, POTENCY_TYPES.TAC, tacPotencyRangeV2), _obj;
};
var getPotencyValues = function(product) {
    if (!product) {
        return {};
    }
    var ranges = getPotencyRanges(product);
    var _obj;
    return _obj = {}, _define_property(_obj, POTENCY_TYPES.CBD, _.max(ranges[POTENCY_TYPES.CBD])), _define_property(_obj, POTENCY_TYPES.THC, _.max(ranges[POTENCY_TYPES.THC])), _define_property(_obj, POTENCY_TYPES.TAC, _.max(ranges[POTENCY_TYPES.TAC])), _obj;
};
export var getProductTHCInGrams = function(param) {
    var product = param.product, quantity = param.quantity;
    var defaultWeight = product.defaultWeight;
    return safeToBig(quantity).times(Number(getPotencyValues(product).THC) || defaultWeight).div(MG_TO_G);
};
export var getProductTHCBasedOnWeight = function(param) {
    var product = param.product, quantity = param.quantity;
    var defaultWeight = product.defaultWeight, Options = product.Options;
    var weight = getProductWeight(Options, defaultWeight, quantity);
    return weight;
};
var applyThcVarianceTolerance = function(thcInGrams) {
    var limits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var thcVarianceTolerance = limits.thcVarianceTolerance;
    if (thcVarianceTolerance) {
        return Number(safeToBig(thcInGrams).div(1 + thcVarianceTolerance));
    }
    return thcInGrams;
};
export var getFlowerEquivalent = function(order, medical) {
    var limits = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, useMultiSubcategories = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var product = order.product, option = order.option, quantity = order.quantity;
    var defaultWeight = product.defaultWeight, type = product.type;
    var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
    var _limits_baseConcentrateOffWeight = limits.baseConcentrateOffWeight, baseConcentrateOffWeight = _limits_baseConcentrateOffWeight === void 0 ? true : _limits_baseConcentrateOffWeight, _limits_baseTincturesOffWeight = limits.baseTincturesOffWeight, baseTincturesOffWeight = _limits_baseTincturesOffWeight === void 0 ? false : _limits_baseTincturesOffWeight;
    var _product_multiplier;
    var multiplier = (_product_multiplier = product.multiplier) !== null && _product_multiplier !== void 0 ? _product_multiplier : 1;
    var standardEquivalent = getEquivalent(product, option, quantity);
    var recEquivalent = getEquivalent(product, option, quantity, 'recEquivalent');
    /*
   * This logic is just to allow IL dispensaries to pass the standardEquivalent field on products
   * even though it shouldn't be used due to their config using equivalency for medical but not recreational
   * orders. IL is the only state config that includes the limits.ignoreStandardEquivalentField
   * - Mack H. 11/5/21
   */ var allowStandardEquivalentFieldUse = !(limits === null || limits === void 0 ? void 0 : limits.ignoreStandardEquivalentField);
    if (_.isFinite(recEquivalent) && !medical) {
        return recEquivalent;
    }
    if (_.isFinite(standardEquivalent) && allowStandardEquivalentFieldUse) {
        return standardEquivalent;
    }
    var weightInGrams;
    if ((limits === null || limits === void 0 ? void 0 : limits.solidNetWeightMultiplier) && isSolidEdibleTypeProduct(type, subcategories)) {
        weightInGrams = getProductNetWeightInGrams(product) * quantity;
        return parseFloat(safeToBig(weightInGrams).times(multiplier));
    }
    if ((limits === null || limits === void 0 ? void 0 : limits.liquidNetWeightMultiplier) && isLiquidTypeProduct(limits, type, subcategories)) {
        weightInGrams = getProductVolumeInGrams(product) * quantity;
        /*
     * Sometimes users of TechPOS will still use the netWeight in measurements rather than volume as suggested
     * so this just acts as a double check for that scenario
     */ if (weightInGrams === 0) {
            weightInGrams = getProductNetWeightInGrams(product) * quantity;
        }
        return parseFloat(safeToBig(weightInGrams).times(multiplier));
    }
    weightInGrams = isEdible(type) || isTincture(type) && !baseTincturesOffWeight || isTopical(type) || isConcentrate(type) && !baseConcentrateOffWeight ? getProductTHCInGrams(order) : getProductWeight(option, defaultWeight, quantity);
    return parseFloat(safeToBig(weightInGrams).times(multiplier));
};
export var getEdibleTHCInGrams = function(order) {
    var type = order.product.type;
    return isEdible(type) ? getProductTHCInGrams(order) : 0;
};
export var getTinctureTHCInGrams = function(order) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_baseTincturesOffWeight = _ref.baseTincturesOffWeight, baseTincturesOffWeight = _ref_baseTincturesOffWeight === void 0 ? false : _ref_baseTincturesOffWeight;
    var type = order.product.type;
    if (baseTincturesOffWeight) {
        return isTincture(type) ? getProductTHCBasedOnWeight(order) : 0;
    }
    return isTincture(type) ? getProductTHCInGrams(order) : 0;
};
export var getTopicalTHCInGrams = function(order) {
    var type = order.product.type;
    return isTopical(type) ? getProductTHCInGrams(order) : 0;
};
export var getTotalFlowerInGrams = function(param) {
    var limits = param.limits, orders = param.orders, medical = param.medical, useMultiSubcategories = param.useMultiSubcategories;
    return Number(_.reduce(orders, function(previous, order) {
        var _limits_ignoreTypeMap_Flower, _limits_ignoreTypeMap;
        /**
         * Prevent any excluded subcategories from triggering state flower limits unless
         * we still need to check equivalency. For example in NV infused pre-rolls are counted as
         * concentrates but need to still count to the overall flower limit
         */ var subcategories = getEffectiveSubcategories(order.product, useMultiSubcategories);
        if (_.intersection(limits === null || limits === void 0 ? void 0 : (_limits_ignoreTypeMap = limits.ignoreTypeMap) === null || _limits_ignoreTypeMap === void 0 ? void 0 : (_limits_ignoreTypeMap_Flower = _limits_ignoreTypeMap.Flower) === null || _limits_ignoreTypeMap_Flower === void 0 ? void 0 : _limits_ignoreTypeMap_Flower.subcategories, subcategories).length > 0 && !shouldCombine(limits, medical)) {
            return safeToBig(previous);
        }
        return safeToBig(previous).plus(safeToBig(getFlowerEquivalent(order, medical, limits, useMultiSubcategories)));
    }, 0));
};
export var getTotalTinctureTHCInGrams = function(param) {
    var orders = param.orders, limits = param.limits;
    return Number(_.reduce(orders, function(previous, order) {
        return safeToBig(previous).plus(safeToBig(getTinctureTHCInGrams(order, limits)));
    }, 0.0));
};
export var getTotalTopicalTHCInGrams = function(param) {
    var orders = param.orders, _param_limits = param.limits, limits = _param_limits === void 0 ? {} : _param_limits, useMultiSubcategories = param.useMultiSubcategories;
    return Number(_.reduce(orders, function(previous, order) {
        var _limits_ignoreTypeMap_Topicals, _limits_ignoreTypeMap, _limits_ignoreTypeMap_Topicals1, _limits_ignoreTypeMap1;
        var product = order.product;
        var type = product.type;
        var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
        var categoryIgnored = _.includes(limits === null || limits === void 0 ? void 0 : (_limits_ignoreTypeMap = limits.ignoreTypeMap) === null || _limits_ignoreTypeMap === void 0 ? void 0 : (_limits_ignoreTypeMap_Topicals = _limits_ignoreTypeMap.Topicals) === null || _limits_ignoreTypeMap_Topicals === void 0 ? void 0 : _limits_ignoreTypeMap_Topicals.categories, type);
        var subcategoryIgnored = _.intersection(limits === null || limits === void 0 ? void 0 : (_limits_ignoreTypeMap1 = limits.ignoreTypeMap) === null || _limits_ignoreTypeMap1 === void 0 ? void 0 : (_limits_ignoreTypeMap_Topicals1 = _limits_ignoreTypeMap1.Topicals) === null || _limits_ignoreTypeMap_Topicals1 === void 0 ? void 0 : _limits_ignoreTypeMap_Topicals1.subcategories, subcategories).length > 0;
        var shouldCheckWeightForType = !categoryIgnored && !subcategoryIgnored;
        return shouldCheckWeightForType ? safeToBig(previous).plus(safeToBig(getTopicalTHCInGrams(order))) : safeToBig(previous);
    }, 0.0));
};
export var getTotalEdibleTHCInGrams = function(param) {
    var orders = param.orders, _param_limits = param.limits, limits = _param_limits === void 0 ? {} : _param_limits, useMultiSubcategories = param.useMultiSubcategories;
    return Number(_.reduce(orders, function(previous, order) {
        var product = order.product;
        var type = product.type;
        var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
        var _limits_baseEdiblesOffWeight = limits.baseEdiblesOffWeight, baseEdiblesOffWeight = _limits_baseEdiblesOffWeight === void 0 ? false : _limits_baseEdiblesOffWeight;
        var edibleCategories = _.get(limits, 'typeMap.Edible.categories', EDIBLE_TYPES);
        var edibleSubcategories = _.get(limits, 'typeMap.Edible.subcategories', []);
        var isEdibleType = _.includes(edibleCategories, type) || _.intersection(edibleSubcategories, subcategories).length > 0;
        if (baseEdiblesOffWeight) {
            return isEdibleType ? safeToBig(previous).plus(safeToBig(getProductTHCBasedOnWeight(order))) : safeToBig(previous);
        }
        return isEdibleType ? safeToBig(previous).plus(safeToBig(getProductTHCInGrams(order))) : safeToBig(previous);
    }, 0.0));
};
export var getTotalConcentrateInGrams = function(param) {
    var orders = param.orders, _param_limits = param.limits, limits = _param_limits === void 0 ? {} : _param_limits, medical = param.medical, state = param.state, useMultiSubcategories = param.useMultiSubcategories;
    return Number(_.reduce(orders, function(previous, order) {
        var _limits_ignoreTypeMap_Concentrate, _limits_ignoreTypeMap, _limits_ignoreTypeMap_Concentrate1, _limits_ignoreTypeMap1;
        var product = order.product, quantity = order.quantity, option = order.option;
        var defaultWeight = product.defaultWeight, type = product.type;
        var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
        var _limits_baseConcentrateOffWeight = limits.baseConcentrateOffWeight, baseConcentrateOffWeight = _limits_baseConcentrateOffWeight === void 0 ? true : _limits_baseConcentrateOffWeight;
        var isWeighted = isWeightedProduct(product);
        var concentrateCategories = _.get(limits, 'typeMap.Concentrate.categories', CONCENTRATE_TYPES);
        var concentrateSubcategories = _.get(limits, 'typeMap.Concentrate.subcategories', []);
        // NOTE: pre-existing quirk - checks subcategories against the ignoreTypeMap *categories* list, not type
        var categoryIgnored = _.intersection(limits === null || limits === void 0 ? void 0 : (_limits_ignoreTypeMap = limits.ignoreTypeMap) === null || _limits_ignoreTypeMap === void 0 ? void 0 : (_limits_ignoreTypeMap_Concentrate = _limits_ignoreTypeMap.Concentrate) === null || _limits_ignoreTypeMap_Concentrate === void 0 ? void 0 : _limits_ignoreTypeMap_Concentrate.categories, subcategories).length > 0;
        var subcategoryIgnored = _.intersection(limits === null || limits === void 0 ? void 0 : (_limits_ignoreTypeMap1 = limits.ignoreTypeMap) === null || _limits_ignoreTypeMap1 === void 0 ? void 0 : (_limits_ignoreTypeMap_Concentrate1 = _limits_ignoreTypeMap1.Concentrate) === null || _limits_ignoreTypeMap_Concentrate1 === void 0 ? void 0 : _limits_ignoreTypeMap_Concentrate1.subcategories, subcategories).length > 0;
        var shouldCheckWeightForType = !categoryIgnored && !subcategoryIgnored;
        var isBritishColumbiaDispensary = state === 'BC';
        var flowerEquivalent = getFlowerEquivalent(order, medical, limits, useMultiSubcategories);
        var useEquivalent = isBritishColumbiaDispensary && !!flowerEquivalent;
        var productWeight = baseConcentrateOffWeight && isWeighted ? getProductWeight(option, defaultWeight, quantity) : getProductTHCInGrams(order);
        return shouldCheckWeightForType && _.includes(concentrateCategories, type) || _.intersection(concentrateSubcategories, subcategories).length > 0 ? safeToBig(previous).plus(safeToBig(useEquivalent ? flowerEquivalent : productWeight)) : safeToBig(previous);
    }, 0.0));
};
export var getSerializedOrders = function(param) {
    var cart = param.cart, limits = param.limits, medical = param.medical, state = param.state, useMultiSubcategories = param.useMultiSubcategories;
    var defaultOptionWeights = getComplianceConfig(state, 'defaults');
    var applicableOrders = _.filter(cart, function(param) {
        var product = param.product;
        return _.includes(CANNABIS_TYPES, product.type);
    });
    return _.map(applicableOrders, function(order) {
        var product = order.product, quantity = order.quantity, option = order.option;
        var type = product.type;
        var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
        var serializedProduct = _object_spread_props(_object_spread({}, product), {
            multiplier: getMultiplier(type, limits, medical, subcategories),
            defaultWeight: defaultOptionWeights[type]
        });
        return {
            product: serializedProduct,
            quantity: quantity,
            option: option
        };
    });
};
export var getSerializedCart = function(param) {
    var state = param.state, cart = param.cart, purchaseState = param.purchaseState, medical = param.medical, useMultiSubcategories = param.useMultiSubcategories;
    // purchaseState is the customer's state, state is the dispensary's state
    var limits = getStateLimits(state, purchaseState);
    var orders = getSerializedOrders({
        cart: cart,
        limits: limits,
        medical: medical,
        state: state,
        useMultiSubcategories: useMultiSubcategories
    });
    return {
        orders: orders,
        state: state,
        limits: limits,
        medical: medical,
        useMultiSubcategories: useMultiSubcategories
    };
};
export var checkFlowerLimit = function(cart) {
    var limits = cart.limits, medical = cart.medical, state = cart.state, useMultiSubcategories = cart.useMultiSubcategories;
    var flowerLimit = getTypeLimits(cart).flowerLimit;
    var mixedTypesInCart = cartHasMix(cart);
    var shouldCombineAmounts = shouldCombine(limits, medical);
    var isMixOrder = mixedTypesInCart && shouldCombineAmounts;
    // This was added to allow for product specific limit messages even when equivalency is triggered for
    // orders that are of a single product to improve compliance messaging in Canada - Mack H. 3/15/2021
    var isEquivalencyWithSingleType = !mixedTypesInCart && shouldCombineAmounts;
    var limitMessage = getLimitMessage("".concat(isMixOrder ? 'cannabis' : 'flower'), flowerLimit, state);
    if (isEquivalencyWithSingleType) {
        var productTypeAndSubcategory = _.head(_.map(cart.orders, function(param) {
            var product = param.product;
            return {
                type: product.type,
                subcategory: product.subcategory,
                subcategories: product.subcategories
            };
        }));
        var productLimit = getLimitForType(productTypeAndSubcategory, cart, useMultiSubcategories);
        var typeToDisplay = productTypeAndSubcategory.type;
        var subcategoriesForDisplay = getEffectiveSubcategories(productTypeAndSubcategory, useMultiSubcategories);
        if (limits.usesLiquidTypes && isLiquidTypeProduct(limits, typeToDisplay, subcategoriesForDisplay)) {
            typeToDisplay = 'liquids';
            productLimit *= GRAMS_PER_OUNCE;
        }
        if (productTypeAndSubcategory.type !== 'Seeds') {
            limitMessage = getLimitMessage(formatDisplayedType(typeToDisplay), productLimit, state);
        } else {
            limitMessage = getLimitMessage('cannabis', flowerLimit, state);
        }
    }
    var totalFlowerInGrams = getTotalFlowerInGrams(cart);
    return totalFlowerInGrams > flowerLimit ? {
        type: 'Flower',
        total: totalFlowerInGrams,
        message: limitMessage,
        withinLimits: false
    } : {
        withinLimits: true
    };
};
export var checkEdibleTHCLimit = function(cart) {
    var state = cart.state, limits = cart.limits;
    var _getTypeLimits = getTypeLimits(cart), edibleTHCLimit = _getTypeLimits.edibleTHCLimit, ignoreEdibleLimit = _getTypeLimits.ignoreEdibleLimit;
    if (ignoreEdibleLimit) {
        return {
            withinLimits: true
        };
    }
    var totalEdibleTHCInGrams = applyThcVarianceTolerance(getTotalEdibleTHCInGrams(cart), limits);
    return totalEdibleTHCInGrams > edibleTHCLimit ? {
        type: 'Edible',
        total: totalEdibleTHCInGrams,
        message: getLimitMessage('edible THC', edibleTHCLimit, state, 'mg'),
        withinLimits: false
    } : {
        withinLimits: true
    };
};
export var checkConcentrateLimit = function(cart) {
    var state = cart.state;
    var concentrateLimit = getTypeLimits(cart).concentrateLimit;
    var totalConcentrateInGrams = getTotalConcentrateInGrams(cart);
    return totalConcentrateInGrams > concentrateLimit ? {
        type: 'Concentrate',
        total: totalConcentrateInGrams,
        message: getLimitMessage('concentrates', concentrateLimit, state),
        withinLimits: false
    } : {
        withinLimits: true
    };
};
export var checkTinctureLimit = function(cart) {
    var state = cart.state, limits = cart.limits;
    var tinctureLimit = getTypeLimits(cart).tinctureLimit;
    var totalTinctureTHCInGrams = applyThcVarianceTolerance(getTotalTinctureTHCInGrams(cart), limits);
    return totalTinctureTHCInGrams > tinctureLimit ? {
        type: 'Tincture',
        total: totalTinctureTHCInGrams,
        message: getLimitMessage('tinctures', tinctureLimit, state),
        withinLimits: false
    } : {
        withinLimits: true
    };
};
export var checkTopicalLimit = function(cart) {
    var state = cart.state, limits = cart.limits;
    var topicalLimit = getTypeLimits(cart).topicalLimit;
    var totalTopicalTHCInGrams = applyThcVarianceTolerance(getTotalTopicalTHCInGrams(cart), limits);
    return totalTopicalTHCInGrams > topicalLimit ? {
        type: 'Topicals',
        total: totalTopicalTHCInGrams,
        message: getLimitMessage('topicals', topicalLimit, state),
        withinLimits: false
    } : {
        withinLimits: true
    };
};
export var checkNonFlowerLimit = function(cart) {
    var state = cart.state, limits = cart.limits;
    var nonFlowerLimit = getTypeLimits(cart).nonFlowerLimit;
    if (nonFlowerLimit) {
        // choose any of these non-flower limits as our baseline for comparison
        var totalTopicalTHCInGrams = getTotalTopicalTHCInGrams(cart);
        var totalTinctureTHCInGrams = getTotalTinctureTHCInGrams(cart);
        var totalConcentrateInGrams = getTotalConcentrateInGrams(cart);
        var totalEdibleTHCInGrams = getTotalEdibleTHCInGrams(cart);
        // Variance tolerance only applies to THC-based amounts, not weight-based concentrates
        var nonFlowerTHCSum = applyThcVarianceTolerance(totalTopicalTHCInGrams + totalTinctureTHCInGrams + totalEdibleTHCInGrams, limits) + totalConcentrateInGrams;
        return nonFlowerTHCSum > nonFlowerLimit ? {
            type: 'Non-Flower',
            total: nonFlowerTHCSum,
            message: getLimitMessage('non-flower items', nonFlowerLimit, state),
            withinLimits: false
        } : {
            withinLimits: true
        };
    }
    return {
        withinLimits: true
    };
};
var updateLimits = function(cart, dispensary) {
    var usePotencyForConcentrateLimits = _.get(dispensary, 'storeSettings.usePotencyForConcentrateLimits', false);
    var useStandardEquivalentForEdiblesLimits = _.get(dispensary, 'storeSettings.useStandardEquivalentForEdiblesLimits', false);
    var state = cart.state;
    if (useStandardEquivalentForEdiblesLimits) {
        cart.limits.ignoreEdibleLimit = true;
    }
    if (state === 'MA') {
        cart.limits.baseConcentrateOffWeight = !usePotencyForConcentrateLimits;
    }
    return cart;
};
export var checkLimits = function(orderData) {
    var cart = getSerializedCart(orderData);
    var _orderData_dispensary = orderData.dispensary, dispensary = _orderData_dispensary === void 0 ? {} : _orderData_dispensary;
    cart = updateLimits(cart, dispensary);
    var messageOverride = _.get(cart, 'limits.message', null);
    if (_.isEmpty(cart.orders)) {
        return {
            withinLimits: true
        };
    }
    return _.reduce([
        checkFlowerLimit,
        checkNonFlowerLimit,
        checkEdibleTHCLimit,
        checkConcentrateLimit,
        checkTinctureLimit,
        checkTopicalLimit,
        checkSolidEdibleNetWeight,
        checkLiquidEdibleVolume
    ], function(previous, limitChecker) {
        var result = limitChecker(cart);
        if (messageOverride) {
            result.message = messageOverride;
        }
        if (!result.withinLimits && result.type) {
            result.typesOverLimit = previous.typesOverLimit ? _to_consumable_array(previous.typesOverLimit).concat([
                result.type
            ]) : [
                result.type
            ];
        }
        return !result.withinLimits ? result : previous;
    }, {
        withinLimits: true
    });
};
